import { render } from "./ServerList.vue?vue&type=template&id=ced7ec12&scoped=true"
import script from "./ServerList.vue?vue&type=script&lang=js"
export * from "./ServerList.vue?vue&type=script&lang=js"

import "./ServerList.vue?vue&type=style&index=0&id=ced7ec12&lang=scss&scoped=true"

import exportComponent from "/var/www/miniapp-sigur-admin-panel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ced7ec12"],['__file',"src/assets/js/pages/Gate/ServerList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ced7ec12"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ced7ec12', __exports__)) {
    api.reload('ced7ec12', __exports__)
  }
  
  module.hot.accept("./ServerList.vue?vue&type=template&id=ced7ec12&scoped=true", () => {
    api.rerender('ced7ec12', render)
  })

}


export default __exports__